import Link from '@components/Link';
import React from 'react';

import PropTypes from 'prop-types';

import './ListItem.scss';

import { IoIosArrowForward } from 'react-icons/io';

ListItem.propTypes = {
    theme: PropTypes.oneOf(['dark', 'white', 'danger']),
    align: PropTypes.oneOf(['left', 'center', 'right']),
    size: PropTypes.oneOf(['xs', 's', 'm', 'l']),
    type: PropTypes.oneOf(['navigation', 'bool', 'externalLink']),
    hasDivider: PropTypes.bool,
    to: PropTypes.string,
    icon: PropTypes.any,
    avatar: PropTypes.any,
};

ListItem.defaultProps = {
    theme: 'dark',
    align: 'left',
    size: 'm',
    type: 'navigation',
    hasDivider: true,
    to: '/',
    icon: undefined,
    avatar: undefined,
};

export default function ListItem(props) {
    const mod_class = [
        'ListItem',
        props.align !== undefined ? 'align-' + props.align : '',
        props.size !== undefined ? 'size-' + props.size : '',
        props.theme !== undefined ? 'theme-' + props.theme : '',
        props.className !== undefined ? props.className : '',
        props.hasDivider !== undefined ? 'has-divider' : '',
    ]
        .join(' ')
        .replace(/\s{2,}/g, ' ');

    return (
        <li className={mod_class}>
            <Link
                to={props.to}
                className="ListItem--Link"
                activeClassName="is-active"
            >
                {props.children}
            </Link>
            <i className="ListItem--icon">
                <IoIosArrowForward />
            </i>
        </li>
    );
}
